module.exports = __webpack_public_path__ + "static/media/4_Treasurer_Karen Chan.383df848.jpeg";